import { FunctionComponent, memo } from 'react';

import classes from './DropdownMenu.module.scss';

interface DropdownMenuProps {
  content: JSX.Element | null | (JSX.Element | null)[];
  maxHeight?: string;
  width?: string;
}

export const DropdownMenu: FunctionComponent<DropdownMenuProps> = memo(
  ({ content, maxHeight, width }) => {
    return (
      <div className={classes['dropdown-menu']} style={{ maxHeight, width }}>
        {content}
      </div>
    );
  }
);
